exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adminMatchingDoctorSelectTableWrapper .b-table{min-width:1100px}.adminMatchingDoctorSelectTableWrapper .b-table td,.adminMatchingDoctorSelectTableWrapper .b-table th{font-size:.75rem}.adminMatchingDoctorSelectTableWrapper .b-table .tdMedicalCourseName{overflow-x:scroll;white-space:pre;width:240px;padding:5px 0;box-sizing:border-box;line-height:.8}", ""]);

// exports
